export const DashboardTimeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
        <path
            fill="#666"
            d="M12 4c-.275 0-.5.225-.5.5v3c0 .275.225.5.5.5s.5-.225.5-.5V5.019A7 7 0 1 1 7.05 7.05a.502.502 0 0 0 0-.706.502.502 0 0 0-.706 0A8 8 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8ZM9.353 8.647a.502.502 0 0 0-.706 0 .502.502 0 0 0 0 .706l3 3a.502.502 0 0 0 .706 0 .502.502 0 0 0 0-.706l-3-3Z"
        />
    </svg>
);
